import { Component, Prop, Vue } from 'vue-property-decorator'

import { faTriangleExclamation } from '@fortawesome/free-solid-svg-icons'
import { library } from '@fortawesome/fontawesome-svg-core'

library.add(faTriangleExclamation)

@Component({
	components: {},
})
export default class ButtonGroups extends Vue {
	@Prop({ default: false }) show!: boolean

	id = ''

	mounted(string) {
		this.id = 'tooltip-modified-' + Math.round(Math.random() * 100000000000)
	}
}
